export default __webpack_public_path__ + "static/media/bdswissReal05_downloadMT4.6bddaae6.png";